/**
 * Identity headers (`X-Assilya-User-*`) carrying the visitor known to the host
 * page, when `init()` was given a `userContext`.
 *
 * An HTTP header value is a byte string, not text: `fetch()` sends every code
 * unit as a single ISO-8859-1 byte, so "Mara Götz" would reach the server as
 * invalid UTF-8 (stored as an unrecoverable "Mara G?tz"), and a name holding a
 * code point above U+00FF ("Łukasz", "Ελένη", "王") makes the call throw
 * outright. Non-ASCII values therefore travel RFC 2047 encoded — the same
 * ASCII-safe transport mail headers use — and Assilya decodes them on arrival.
 */
export function identityHeaders(userContext) {
    const headers = {};

    if (!userContext || typeof userContext !== 'object') {
        return headers;
    }

    if (userContext.userId) headers['X-Assilya-User-Id'] = encodeHeaderValue(userContext.userId);
    if (userContext.email) headers['X-Assilya-User-Email'] = encodeHeaderValue(userContext.email);
    if (userContext.name) headers['X-Assilya-User-Name'] = encodeHeaderValue(userContext.name);

    return headers;
}

/**
 * Printable ASCII travels as-is (the overwhelming majority of ids and emails);
 * anything else — accents, non-Latin scripts, emoji, stray control characters
 * a header could not carry anyway — becomes `=?UTF-8?B?<base64>?=`.
 */
function encodeHeaderValue(raw) {
    const value = String(raw);

    if (/^[\x20-\x7e]*$/.test(value)) {
        return value;
    }

    const bytes = new TextEncoder().encode(value);
    let binary = '';

    for (let i = 0; i < bytes.length; i += 1) {
        binary += String.fromCharCode(bytes[i]);
    }

    return '=?UTF-8?B?' + btoa(binary) + '?=';
}
